import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleTagManagerNoscript","GoogleTagManagerLoader"] */ "/vercel/path0/src/components/analytics/GoogleTagManagerLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppDownloadBanner"] */ "/vercel/path0/src/components/AppDownloadBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CapacitorStartup"] */ "/vercel/path0/src/components/capacitor/CapacitorStartup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/AppHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExternalLink"] */ "/vercel/path0/src/components/links/ExternalLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InstallAppBanner"] */ "/vercel/path0/src/components/pwa/InstallAppBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwRegister"] */ "/vercel/path0/src/components/pwa/SwRegister.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/system/ToasterClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/src/context/AuthContext.tsx");
